import { Source } from "@hooks/chat/types";
import { Typography } from "@pondigitalsolutions/pon-component-library";
import { useTranslation } from "react-i18next";
import { LinkExternal02 } from "untitledui-js/react";

type SourcesProps = {
  sources: Source[];
  isLoading: boolean;
};

export const Sources = ({ sources, isLoading }: SourcesProps) => {
  const { t } = useTranslation();

  // Guard clause to handle empty sources
  if (sources.length === 0 && !isLoading) {
    return null;
  }

  return (
    <div className="flex h-full w-full flex-col">
      <div className="w-full flex-1">
        <Typography
          className="mb-4 text-sm font-normal text-white"
          data-testid="search-sources-title"
        >
          {t("SearchResults.sources")}
        </Typography>
        {/* Loading phase - show skeleton UI */}
        {isLoading && (
          <div className="space-y-2" data-testid="search-sources-loading">
            {/* Create an Array with n items and use to create n loading placeholders */}
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={`loading-placeholder-${index}`}>
                <div className="h-9 animate-pulse rounded-lg bg-tertiary-400 dark:bg-tertiary-700" />
              </div>
            ))}
          </div>
        )}
        <menu className="mb-4 flex flex-col gap-2">
          {sources.map((source) => {
            const href = /^(https?:\/\/|\/)/.test(source.link)
              ? source.link
              : `/${source.link}`;

            return (
              <li key={source.path}>
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-between rounded-lg bg-white/10 px-4 py-2 text-sm text-white transition-colors duration-300 hover:bg-white/20"
                >
                  <span className="flex flex-col">
                    <span className="line-clamp-1">{source.label}</span>
                    <span className="line-clamp-1 break-all text-white/60">
                      {source.path}
                    </span>
                  </span>
                  <LinkExternal02 className="h-4 w-4 shrink-0" />
                </a>
              </li>
            );
          })}
        </menu>
      </div>
    </div>
  );
};
